'use strict';

import { Component, Input, OnDestroy } from '@angular/core';

@Component({
    selector: 'spinner-small',
    standalone: false,
    templateUrl: './spinner-small.component.html'
})
export class SpinnerSmallComponent implements OnDestroy {

    public showSpinner: boolean = false;

    @Input()
    public delay: number = 300;
    @Input()
    public extraSmall: boolean = false;

    @Input()
    public set isRunning(value: boolean) {
        this.showSpinner = !!value;
    }

    get spinnerDiameter(): number {
        return this.extraSmall ? 24 : 36;
    }

    ngOnDestroy(): any {

    }

}